import { CloseOutlined } from '@ant-design/icons';
import AppButton from '@nxsys/components/AppButton';
import AppFormContainer from '@nxsys/components/AppFormContainer';
import AppModalContainer from '@nxsys/components/AppModalContainer';
import AppSelectSync from '@nxsys/components/AppSelectSync';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { Option } from '@nxsys/types/models/Common';
import { Form } from 'antd';
import { FormProps } from 'antd/lib';
import React from 'react';

type AttachmentOrdersFilterModalProps = {
  isOpen: boolean;
  toggle: () => void;
  onFilter: (params: AttachmentOrdersFilterValues) => void;
};

export type AttachmentOrdersFilterValues = {
  subcontractor: Option<string> | null;
};

const AttachmentOrdersFilterModal: React.FC<
  AttachmentOrdersFilterModalProps
> = ({ isOpen, toggle, onFilter }: AttachmentOrdersFilterModalProps) => {
  const { messages } = useTypedIntl();

  const [form] = Form.useForm();
  const watchValue = Form.useWatch([], form);
  const ableToClearFilter =
    watchValue && Object.keys(watchValue).some((key) => !!watchValue[key]);

  const handleClearAll = (e: React.MouseEvent) => {
    e.stopPropagation();
    form.resetFields();
  };

  const onFinish: FormProps['onFinish'] = (values) => {
    onFilter(values);
    toggle();
  };

  const onFinishFailed: FormProps['onFinishFailed'] = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <AppModalContainer
      title={messages['common.filter']}
      isOpen={isOpen}
      toggle={toggle}
      actions={[
        {
          name: messages['common.cancel'],
          variant: 'outlined',
          onClick: toggle,
        },
        {
          name: messages['common.apply'],
          buttonType: 'primary',
          onClick: () => form.submit(),
        },
      ]}
      closeIcon={
        <div style={{ marginRight: 90 }}>
          <AppButton
            name={messages['common.clearAll']}
            leftIcon={<CloseOutlined />}
            onClick={handleClearAll as any}
            disabled={!ableToClearFilter}
          />
        </div>
      }
      minHeight="200px"
    >
      <AppFormContainer
        form={form}
        onFinish={onFinish}
        onFinishFailed={onFinishFailed}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <Form.Item label={messages['table.employeeName']} name="subcontractor">
          <AppSelectSync
            type="emp&sub"
            apiType="searchEmployeeSubcontractV2"
            placeholder={messages['form.pleaseSelect']}
            paramFilter={{ paymentModel: 'PAYEE' }}
            onChangeValue={(value) => {
              form.setFieldsValue({
                subcontractor: value,
              });
            }}
          />
        </Form.Item>
      </AppFormContainer>
    </AppModalContainer>
  );
};

export default AttachmentOrdersFilterModal;
